const booking = {
  id: "String",
  createdById: "String",
  endedById: "String",
  dateCreated: "Timestamp",
  customerId: "String",
  vehicleId: "String",
  locationId: "String",
  startDate: "Timestamp",
  endDate: "Timestamp",
  totalDays: "Int",
  delivery: "Boolean",
  dropOffLocation: "String",
  pickUpLocation: "String",
  bookingFees: "Float",
  deliveryFees: "Float",
  taxes: "Float",
  subtotal: "Float",
  totalFees: "Float",
  startFuel: "Int",
  endFuel: "Int",
  mileageRate: "Float",
  milesIncluded: "Int",
  startMileage: "Int",
  endMileage: "Int",
  checkInImages: "[String!]",
  checkOutImages: "[String!]",
  status: "String",
  rating: "Int",
  automaticExtension: "Boolean",
  agreement: "String",
};

const extension = {
  id: "String",
  createdById: "String",
  dateCreated: "Timestamp",
  bookingId: "String",
  endDate: "Timestamp",
  bookingFees: "Float",
  subtotal: "Float",
  taxes: "Float",
  totalFees: "Float",
  dropOffLocation: "String",
  milesIncluded: "Int",
  mileageRate: "Float",
  paymentId: "String",
};

const charging = {
  id: "String",
  dateCreated: "Timestamp",
  date: "Timestamp",
  country: "String",
  description: "String",
  invoice: "String",
  invoiceNumber: "String",
  model: "String",
  name: "String",
  quantityBase: "String",
  quantityTier1: "String",
  quantityTier2: "String",
  quantityTier3: "String",
  quantityTier4: "String",
  location: "String",
  status: "String",
  fee: "String",
  total: "String",
  rate: "String",
  unitCostTier1: "String",
  unitCostTier2: "String",
  unitCostTier3: "String",
  unitCostTier4: "String",
  taxRate: "String",
  vin: "String",
  bookingId: "String",
  vehicleId: "String",
  invoiced: "Boolean",
  invoiceDate: "Timestamp",
};

const coupon = {
  dateCreated: "Timestamp",
  createdById: "String",
  id: "String",
  amount: "Float",
  customerId: "String",
  reusable: "Boolean",
  type: "String",
  used: "Boolean",
};

const couponUsage = {
  id: "String",
  dateCreated: "Timestamp",
  couponId: "String",
  paymentId: "String",
};

const customer = {
  id: "String",
  dateCreated: "Timestamp",
  email: "String",
  firstName: "String",
  lastName: "String",
  doNotRent: "Boolean",
  stripeId: "String",
  phone: "String",
  photo: "String",
  signature: "String",
  samsaraId: "String",
  defaultPaymentMethodId: "String",
  driversLicenseBack: "String",
  driversLicenseFront: "String",
  driversLicenseNumber: "String",
  driversLicenseExp: "Timestamp",
  dob: "Timestamp",
  address: "String",
  street: "String",
  street2: "String",
  city: "String",
  state: "String",
  zip: "String",
  country: "String",
  insuranceExp: "Timestamp",
  screeningStatus: "String",
  unpaidInvoices: "Boolean",
  activeBookingId: "String",
  deleted: "Boolean",
  advisorId: "String",
};

const customerSetting = {
  customerId: "String",
  push: "Boolean",
  sms: "Boolean",
  email: "Boolean",
  tokens: "[String!]",
  marketing: "Boolean",
  reminders: "Boolean",
};

const customerPlan = {
  dateCreated: "Timestamp",
  customerId: "String",
  planId: "String",
  trial: "Boolean",
  rate: "Float",
  paymentId: "String",
};

const customerScreening = {
  id: "String",
  customerId: "String",
  dateCreated: "Timestamp",
  status: "String",
  provider: "String",
  link: "String",
  dateCompleted: "Timestamp",
  phone: "String",
  kyc: "String",
  document: "String",
  selfie: "String",
  risk: "String",
};

const quote = {
  id: "String",
  dateCreated: "Timestamp",
  createdById: "String",
  link: "String",
  name: "String",
  email: "String",
  phone: "String",
};

const paymentMethod = {
  id: "String",
  dateCreated: "Timestamp",
  customerId: "String",
  brand: "String",
  last4: "String",
  type: "String",
  accountId: "String",
  deleted: "Boolean",
};

const archives = {
  id: "String",
  dateCreated: "Timestamp",
  createdById: "String",
  type: "String",
  data: "String",
};

const employee = {
  id: "String",
  dateCreated: "Timestamp",
  createdById: "String",
  active: "Boolean",
  name: "String",
  checkedIn: "Boolean",
  locationId: "String",
  email: "String",
  phone: "String",
  photo: "String",
  type: "String",
  ghlId: "String",
};

const employeeAttendance = {
  id: "String",
  dateCreated: "Timestamp",
  employeeId: "String",
  checkin: "Boolean",
  locationId: "String",
};

const reminder = {
  id: "String",
  dateCreated: "Timestamp",
  employeeId: "String",
  date: "Timestamp",
  message: "String",
  completed: "Boolean",
};

const expense = {
  id: "String",
  dateCreated: "Timestamp",
  datePaid: "Timestamp",
  dueDate: "Timestamp",
  status: "String",
  paidVia: "String",
  description: "String",
  createdById: "String",
  requestedById: "String",
  paidById: "String",
  amount: "Float",
  attachment: "String",
  receipt: "String",
  category: "String",
  vehicleId: "String",
  employeeId: "String",
  locationId: "String",
  maintenanceId: "String",
  applicationId: "String",
  partnerId: "String",
  claimId: "String",
};

const invoice = {
  id: "String",
  dateCreated: "Timestamp",
  amount: "Float",
  attachment: "String",
  date: "Timestamp",
  description: "String",
  partnerId: "String",
  applicationId: "String",
  status: "String",
  createdById: "String",
  paidById: "String",
  receipt: "String",
};

const location = {
  id: "String",
  dateCreated: "Timestamp",
  createdById: "String",
  active: "Boolean",
  name: "String",
  address: "String",
  appleMapsLink: "String",
  googleIframe: "String",
  googleMapsLink: "String",
  delivery: "Boolean",
  deliveryRate: "Int",
  phone: "String",
  tax: "Float",
  image: "String",
};

const make = {
  id: "String",
  dateCreated: "Timestamp",
  createdById: "String",
  image: "String",
  name: "String",
};

const note = {
  id: "String",
  dateCreated: "Timestamp",
  customerId: "String",
  bookingId: "String",
  paymentId: "String",
  expenseId: "String",
  vehicleId: "String",
  invoiceId: "String",
  maintenanceId: "String",
  claimId: "String",
  couponId: "String",
  partnerId: "String",
  applicationId: "String",
  employeeId: "String",
  note: "String",
  attachment: "String",
};

const partner = {
  id: "String",
  dateCreated: "Timestamp",
  name: "String",
  phone: "String",
  email: "String",
  address: "String",
  dob: "Timestamp",
  driversLicenseBack: "String",
  driversLicenseFront: "String",
  driversLicenseNumber: "String",
  photo: "String",
  selfieId: "String",
  ssn: "String",
  ssnFront: "String",
  signature: "String",
  creditApp: "Boolean",
  occupation: "String",
  employer: "String",
  employmentYears: "Int",
  monthlyRent: "Float",
  monthlySalary: "Float",
  otherIncome: "Float",
  payStubs: "[String!]",
  monthsAtResidence: "Int",
  yearsAtResidence: "Int",
  residenceType: "String",
  proofOfResidence: "[String!]",
  bankStatements: "[String!]",
  taxReturns: "[String!]",
  creditAppAgreement: "String",
  agreement: "String",
  bankName: "String",
  bankAccount: "String",
  bankRouting: "String",
};

const application = {
  id: "String",
  dateCreated: "Timestamp",
  partnerId: "String",
  vin: "String",
  onboarded: "Boolean",
  make: "String",
  model: "String",
  year: "Int",
  license: "String",
  licenseState: "String",
  registeration: "String",
  registerationExp: "Timestamp",
  insurance: "String",
  insuranceExp: "Timestamp",
  financeAmount: "Float",
  loanAccount: "String",
  apr: "Float",
  institution: "String",
  title: "String",
  loanDocument: "String",
  powerOfAttorney: "String",
  billOfSale: "String",
  vehicleInspectionReport: "String",
  monthlyPayment: "Float",
  lastPayment: "Timestamp",
  dueDate: "Timestamp",
  loanTerm: "Int",
  type: "String",
  agreement: "String",
  vehicleId: "String",
  avgValue: "Float",
  lowValue: "Float",
  highValue: "Float",
  lastValueCheck: "Timestamp",
  valueCertainty: "Float",
  lastValueMileage: "Int",
  depreciationClaimed: "Float",
  lenderId: "String",
  accountId: "String",
};

const lender = {
  id: "String",
  dateCreated: "Timestamp",
  name: "String",
  contact: "String",
  email: "String",
  phone: "String",
  address: "String",
  createdById: "String",
};

const account = {
  id: "String",
  dateCreated: "Timestamp",
  bank: "String",
  routing: "String",
  account: "String",
  type: "String",
  partnerId: "String",
  createdById: "String",
};

const payment = {
  id: "String",
  dateCreated: "Timestamp",
  createdById: "String",
  stripeId: "String",
  stripeLink: "String",
  paymentMethodId: "String",
  type: "String",
  customerId: "String",
  bookingId: "String",
  subtotal: "Float",
  discount: "Float",
  taxes: "Float",
  amount: "Float",
  description: "String",
  daysUntilDue: "Int",
  dueDate: "Timestamp",
  datePaid: "Timestamp",
  paidVia: "String",
  paidToId: "String",
  lastAttemptById: "String",
  lastAttemptDate: "Timestamp",
  refunded: "Float",
  delinquencyDate: "Timestamp",
  category: "String",
  status: "String",
};

const refund = {
  id: "String",
  dateCreated: "Timestamp",
  paymentId: "String",
  stripeId: "String",
  amount: "Float",
  reason: "String",
  employeeId: "String",
};

const plan = {
  id: "String",
  dateCreated: "Timestamp",
  name: "String",
  order: "Int",
  price: "Float",
  features: "[String!]",
  startingAt: "Float",
};

const vehicle = {
  id: "String",
  legacyId: "String",
  dateCreated: "Timestamp",
  createdById: "String",
  makeId: "String",
  model: "String",
  year: "Int",
  vin: "String",
  license: "String",
  licenseState: "String",
  type: "String",
  keyTag: "String",
  locationId: "String",
  planId: "String",
  color: "String",
  trim: "String",
  trackerId: "String",
  immobilizer: "String",
  tollTagId: "String",
  fuel: "String",
  drive: "String",
  doors: "Int",
  seats: "Int",
  cornerImage: "String",
  frontImage: "String",
  backImage: "String",
  sideImage: "String",
  rate: "Float",
  monthlyMiles: "Int",
  status: "String",
  available: "Boolean",
  activeBookingId: "String",
};

const maintenance = {
  id: "String",
  dateCreated: "Timestamp",
  vehicleId: "String",
  description: "String",
  status: "String",
  priority: "Int",
  image: "String",
  reportedById: "String",
  startMileage: "Int",
  dateDiagnosed: "Timestamp",
  diagnosedBy: "String",
  diagnosis: "String",
  dateProgress: "Timestamp",
  progressBy: "String",
  dateCompleted: "Timestamp",
  completedBy: "String",
  endMileage: "Int",
  cost: "Float",
  receipt: "String",
};

const service = {
  id: "String",
  dateCreated: "Timestamp",
  createdById: "String",
  vehicleId: "String",
  description: "String",
  dueDate: "Timestamp",
  intervalMiles: "Int",
  status: "String",
  currentMileage: "Int",
};

const claim = {
  id: "String",
  dateCreated: "Timestamp",
  createdById: "String",
  vehicleId: "String",
  bookingId: "String",
  driverName: "String",
  driverPhone: "String",
  driverEmail: "String",
  driverAddress: "String",
  driverLicense: "String",
  provider: "String",
  policy: "String",
  incidentDate: "Timestamp",
  mileage: "Int",
  weather: "String",
  location: "String",
  description: "String",
  otherName: "String",
  otherPhone: "String",
  otherEmail: "String",
  otherAddress: "String",
  otherLicense: "String",
  otherProvider: "String",
  otherPolicy: "String",
  otherVehicle: "String",
  otherVehicleLicense: "String",
  otherVehicleColor: "String",
  witnessName: "String",
  witnessPhone: "String",
  witnessStatement: "String",
  reportNumber: "String",
  officerName: "String",
  injuries: "Boolean",
  injuryDetails: "String",
  medical: "Boolean",
  receipts: "[String!]",
  report: "String",
  repairName: "String",
  cost: "Float",
  damageDetails: "String",
  images: "[String!]",
  signature: "String",
  claimNumber: "String",
  letter: "String",
  adjusterName: "String",
  adjusterPhone: "String",
  adjusterEmail: "String",
  amountApproved: "Float",
  amountPaid: "Float",
  status: "String",
};

const audit = {
  id: "String",
  dateCreated: "Timestamp",
  employeeId: "String",
  customerId: "String",
  partnerId: "String",
  action: "String",
  table: "String",
  row: "String",
  data: "String",
};

const metadata = {
  id: "String",
  count: "Int",
};

const document = {
  id: "String",
  dateCreated: "Timestamp",
  customerId: "String",
  employeeId: "String",
  partnerId: "String",
  link: "String",
  type: "String",
  expDate: "Timestamp",
};

const phoneNumber = {
  id: "String",
  dateCreated: "Timestamp",
  code: "String",
};

export const schema = {
  booking,
  extension,
  charging,
  coupon,
  couponUsage,
  customer,
  customerSetting,
  customerPlan,
  customerScreening,
  quote,
  paymentMethod,
  archives,
  employee,
  employeeAttendance,
  reminder,
  expense,
  invoice,
  location,
  make,
  note,
  partner,
  application,
  payment,
  refund,
  plan,
  vehicle,
  maintenance,
  service,
  claim,
  audit,
  metadata,
  document,
  phoneNumber,
  account,
  lender,
};

export const keys = {
  booking: "id",
  extension: "id",
  charging: "id",
  coupon: "id",
  couponUsage: "id",
  customer: "id",
  customerSetting: "customerId",
  customerPlan: "customerId",
  customerScreening: "id",
  quote: "id",
  paymentMethod: "id",
  archives: "id",
  employee: "id",
  employeeAttendance: "id",
  reminder: "id",
  expense: "id",
  invoice: "id",
  location: "id",
  make: "id",
  note: "id",
  partner: "id",
  application: "id",
  payment: "id",
  refund: "id",
  refund: "id",
  plan: "id",
  vehicle: "id",
  maintenance: "id",
  service: "id",
  claim: "id",
  audit: "id",
  metadata: "id",
  document: "id",
  phoneNumber: "id",
  account: "id",
  lender: "id",
};

export const getColumns = (table) => {
  if (!schema[table]) throw new Error(`Table ${table} not found in schema.`);
  let columns = "";
  Object.keys(schema[table]).forEach((column) => {
    columns += `${column}, `;
  });
  return columns;
};

export const getKey = (table) => {
  if (!keys[table]) throw new Error(`Key for ${table} not found in schema.`);
  return keys[table];
};

export const getDataType = (table, column) => {
  if (!schema[table]) throw new Error(`Table '${table}' not found in schema.`);
  if (!schema[table][column])
    throw new Error(`Column '${column}' not found in table '${table}'.`);
  return schema[table][column];
};
